export const ACCESS_KEY_LOADING = "ACCESS_KEY_LOADING";
export const ACCESS_KEY_SUCCESS = "ACCESS_KEY_SUCCESS";
export const ACCESS_KEY_FAILED = "ACCESS_KEY_FAILED";
export const ACCESS_KEY_CLEAR = "ACCESS_KEY_CLEAR";
